import script from "./AppAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./AppAutocomplete.vue?vue&type=style&index=0&id=238b9306&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238b9306"]])

export default __exports__